module.exports = "/_next/static/files/4dc49f889b49d8119f8495c932afd283.jpg";